import * as classTypes from "Store/classrooms/constants";

export const updateClassroomSession = (payload) => ({
  type: classTypes.HANDLE_UPDATE_CLASSROOM_SESSION,
  payload
});

// ////////////Pre-Made Worksheets/////////////////////

export const setClassroomCalendarLoading = (payload) => ({
  type: classTypes.SET_CLASSROOM_CALENDAR_LOADING,
  payload
});

/* REFACTORED */

/*
-------------------------------------------
--------- CLASSROOMS MAIN ACTIONS ---------
-------------------------------------------
*/

export const handleFetchClassrooms = (isStats?: boolean): classTypes.IHandleFetchClassrooms => ({
  type: classTypes.HANDLE_FETCH_CLASSROOMS,
  payload: {
    isStats
  }
});

export const handleSetClassroomStats = (
  stats: [],
  classroomId: string
): classTypes.IHandleSetClassroomStats => ({
  type: classTypes.SET_CLASSROOM_STATS,
  payload: {
    stats,
    classroomId
  }
});

export const fetchClassReportPDF = (
  payload: FetchClassroomReportPDF
): classTypes.IHandleFetchClassroomReportPDF => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM_REPORT_PDF,
  payload
});

export const handleFetchClassroomStudents = (): classTypes.IHandleFetchClassroomStudents => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM_STUDENTS
});

export const setClassroomStudents = (
  classroomStudents: Student[]
): classTypes.ISetClassroomStudents => ({
  type: classTypes.SET_CLASSROOM_STUDENTS,
  payload: classroomStudents
});
/*
-------------------------------------------
-------------------------------------------
-------------------------------------------
*/

/*
-------------------------------------------
------- CLASSROOMS LESSONS ACTIONS --------
-------------------------------------------
*/

export const handleRescheduleClassroomLessons = (
  payload: RescheduleClassroomLesson,
  source: Source = "list"
): classTypes.IRescheduleClassroomsLesson => ({
  type: classTypes.HANDLE_RESCHEDULE_CLASSROOM_LESSONS,
  payload,
  source
});

export const handleUnassignClassroomLesson = (
  payload: UnassignClassroomLesson
): classTypes.IUnassignClassroomLesson => ({
  type: classTypes.HANDLE_UNASSIGN_CLASSROOM_LESSON,
  payload
});

export const handleAssignLessonsToClassroom = (
  payload: AssignLessonsClassRequest,
  source: Source = "list",
  problemsCount: number
): classTypes.IHandleAssignLessonsToClass => ({
  type: classTypes.HANDLE_ASSIGN_LESSONS_TO_CLASSROOM,
  payload,
  source,
  problemsCount
});

export const setClassroomLessons = (payload: Lesson[]): classTypes.ISetClassroomLessons => ({
  type: classTypes.SET_CLASSROOM_LESSONS,
  payload
});

export const handleFetchClassroomLessonsList = (): classTypes.IHandleFetchClassroomLessonsList => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM_LESSONS_LIST
});

export const handleFetchClassroomLessons = (): classTypes.IHandleFetchClassroomLessons => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM_LESSONS
});

export const setClassroomActiveLesson = (
  payload: Lesson
): classTypes.ISetClassroomActiveLesson => ({
  type: classTypes.SET_CLASSROOM_ACTIVE_LESSON,
  payload
});
/*
-------------------------------------------
-------------------------------------------
-------------------------------------------
*/

export const handleDeleteClassroom = (payload: string): classTypes.IHandleDeleteClass => ({
  type: classTypes.HANDLE_DELETE_CLASSROOM,
  payload
});

/*
-------------------------------------------
-------------------------------------------
-------------------------------------------
*/

/*
-------------------------------------------
------- CLASSROOMS WORKSHEETS ACTIONS -----
-------------------------------------------
*/

export const handleRescheduleClassroomWorksheets = (
  payload: RescheduleClassroomWorksheetsPayload,
  source: Source = "list"
): classTypes.IHandleRescheduleClassroomWorksheets => ({
  type: classTypes.HANDLE_RESCHEDULE_CLASSROOM_WORKSHEETS,
  payload,
  source
});

export const handleAssignClassroomWorksheets = (
  payload: AssignClassroomWorksheetsPayload,
  source: Source = "list"
): classTypes.IHandleAssignClassroomWorksheets => ({
  type: classTypes.HANDLE_ASSIGN_CLASSROOM_WORKSHEETS,
  payload,
  source
});

export const handleFetchClassroomWorksheetsList =
  (): classTypes.IHandleFetchClassroomWorksheetsList => ({
    type: classTypes.HANDLE_FETCH_CLASSROOM_WORKSHEETS_LIST
  });

export const setClassroomWorksheets = (
  payload: Worksheet[]
): classTypes.ISetClassroomWorksheets => ({
  type: classTypes.SET_CLASSROOM_WORKSHEETS,
  payload
});

export const setClassroomActiveWorksheet = (
  payload: Worksheet
): classTypes.ISetClassroomActiveWorksheet => ({
  type: classTypes.SET_CLASSROOM_ACTIVE_WORKSHEET,
  payload
});

export const handleUnassignClassroomWorksheet = (
  payload: UnassignClassroomWorksheet
): classTypes.IHandleUnassignClassroomWorksheet => ({
  type: classTypes.HANDLE_UNASSIGN_CLASSROOM_WORKSHEET,
  payload
});

/*
-------------------------------------------
------- CLASSROOMS TESTS ACTIONS -----
-------------------------------------------
*/

export const handleFetchClassroomTestsList = (): classTypes.IHandleFetchClassroomTestsList => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM_TESTS_LIST
});

export const handleAssignClassroomTest = (
  payload: AssignTestToClassroomPayload,
  source: Source = "list"
): classTypes.IHandleAssignClassroomTest => ({
  type: classTypes.HANDLE_ASSIGN_CLASSROOM_TEST,
  payload,
  source
});

export const handleUnassignTestFromClassroom = (
  payload: UnassignTestFromClassroomPayload
): classTypes.IHandleUnassignClassroomTest => ({
  type: classTypes.HANDLE_UNASSIGN_CLASSROOM_TEST,
  payload
});

export const handleRescheduleClassroomTest = (
  payload: RescheduleClassroomTest,
  source: Source = "list"
): classTypes.IHandleRescheduleClassroomTest => ({
  type: classTypes.HANDLE_RESCHEDULE_CLASSROOM_TESTS,
  payload,
  source
});

export const setClassroomTests = (payload: Test[]): classTypes.ISetClassroomTests => ({
  type: classTypes.SET_CLASSROOM_TESTS,
  payload
});

export const handleUpdateClassroomTest = (
  payload: UpdateTestPayload,
  testChanges?: TestChangesRequest,
  source: Source = "list"
): classTypes.IHandleUpdateClassroomTest => ({
  type: classTypes.HANDLE_UPDATE_CLASSROOM_TEST,
  payload,
  testChanges,
  source
});

export const setClassroomActiveTest = (payload: Test): classTypes.ISetClassroomActiveTest => ({
  type: classTypes.SET_CLASSROOM_ACTIVE_TEST,
  payload
});

/*
-------------------------------------------
-------------------------------------------
-------------------------------------------
*/
export const handleDeleteMultipleItemsFromClass = (
  payload: DeleteRequest,
  classId
): classTypes.IHandleDeleteMultipleItems => ({
  type: classTypes.HANDLE_DELETE_MULTIPLE_ITEMS_FROM_CLASS,
  payload,
  classId
});

export const handleFetchClassCalendarData = (
  payload: string
): classTypes.IHandleFetchClassCalendarData => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM_CALENDAR_DATA,
  payload
});

export const handleOpenSelectedItemDetailsClassroom = (
  payload: OpenDetailsRequest
): classTypes.IHandleOpenSelectedItemDetailsClassroom => ({
  type: classTypes.HANDLE_OPEN_SELECTED_ITEM_DETAILS_CLASSROOM,
  payload
});

export const setClassrooms = (classrooms: Classroom[]): classTypes.IHandleSetClassrooms => ({
  type: classTypes.SET_CLASSROOMS,
  payload: classrooms
});

export const handleCreateClassroom = (
  payload: CreateClassroomPayload
): classTypes.IHandleCreateClassroom => ({
  type: classTypes.HANDLE_CREATE_CLASSROOM,
  payload
});

export const setActiveClassroom = (payload: Classroom): classTypes.ISetActiveClassroom => ({
  type: classTypes.SET_ACTIVE_CLASSROOM,
  payload
});

/** @params:
 * payload: classroomID
 * */
export const handleFetchClassroom = (payload: string): classTypes.IHandleFetchClassroom => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM,
  payload
});

export const handleUpdateClassroom = (
  payload: ClassroomUpdatePayload,
  source: UpdateSource = "PROFILE"
): classTypes.IHandleUpdateClassroom => ({
  type: classTypes.HANDLE_UPDATE_CLASSROOM,
  payload,
  source
});

export const handleUpdateClassroomArchived = (
  payload: UpdateClassroomArchivedPayload,
  source?: Source
): classTypes.IHandleUpdateClassroomArchived => ({
  type: classTypes.HANDLE_UPDATE_CLASSROOM_ARCHIVED,
  payload,
  source
});

export const handleAddClassroomInstructor = (
  payload: Partial<Instructor>[]
): classTypes.IhandleAddClassroomInstructor => ({
  type: classTypes.HANDLE_ADD_CLASSROOM_INSTRUCTOR,
  payload
});

export const handleAssignClassroomSession = (payload) => ({
  type: classTypes.HANDLE_ASSIGN_CLASSROOM_SESSION,
  payload
});

// --------
/**
 * @params: payload: classroom_lesson_id
 * */
export const handleAssignClassroomAssignmentToStudents = (
  payload: string,
  assignmentType: string
): classTypes.IHandleAssignClassroomAssignmentToStudents => ({
  type: classTypes.HANDLE_ASSIGN_CLASSROOM_ASSIGNMENT_TO_STUDENTS,
  payload,
  assignmentType
});

/**
 * @params: payload: category_ids
 * */
export const handleFetchClassroomWorksheetsByCategories = (
  payload: string[]
): classTypes.IHandleFetchClassroomWorksheetsByCategories => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM_WORKSHEETS_BY_CATEGORIES,
  payload
});

export const setClassroomSummary = (
  classroomSummary: ClassSummary,
  classroomId: string
): classTypes.ISetClassroomSummary => ({
  type: classTypes.SET_CLASSROOM_SUMMARY,
  payload: {
    classroomSummary,
    classroomId
  }
});

export const handleFetchClassroomOverdueStats = (
  classroomId: string
): classTypes.IHandleFetchClassroomOverdueStats => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM_OVERDUE_STATS,
  payload: {
    classroomId
  }
});
export const handleFetchClassroomProblemsStats = (
  classroomId: string
): classTypes.IHandleFetchClassroomProblemsStats => ({
  type: classTypes.HANDLE_FETCH_CLASSROOM_PROBLEMS_STATS,
  payload: {
    classroomId
  }
});
export const setClassroomOverdueStats = (overdue): classTypes.ISetClassroomOverdueStats => ({
  type: classTypes.SET_CLASSROOM_OVERDUE_STATS,
  payload: {
    overdue
  }
});
export const setClassroomProblemsStats = (problems): classTypes.ISetClassroomProblemsStats => ({
  type: classTypes.SET_CLASSROOM_PROBLEMS_STATS,
  payload: {
    problems
  }
});
export const setClassroomsSimplifiedLoading = (
  isLoading: boolean
): classTypes.ISetClassroomsSimplifiedLoading => ({
  type: classTypes.SET_CLASSROOMS_SIMPLIFIED_LOADING,
  payload: {
    isLoading
  }
});
